import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../Buttons';
import { Dropdown } from '../Dropdown';
import { Times, CircleTimes } from '../Icon';
import { Input } from '../Input';
import { selectNewVehicleValue } from '../../modules/Vehicles/selectors';
import { selectNewCompanyValue } from '../../modules/Companies/selectors';
import cn from 'classnames';
import ButtonComponent from '../../containers/App/Components/Button/Button';
import styles from './ManualDropdown.module.css';
import { HBox } from '../Box';
import { AUTOTELEX_VALUES } from '../../modules/Vehicles/constants';
import { SearchSelect } from '../SearchSelectComponent';

const Container = styled.div``;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class ManualDropdownComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    if (this.value && !this.props.options.includes(this.value)) {
      this.props.onManual(true);
    } else {
      this.props.onManual(false);
    }
  }

  get value() {
    if (this.props.model == 'company') {
      return this.props.companyValue;
    }
    if (this.props.model == 'vehicle') {
      return this.props.vehicleValue;
    }
  }

  get manual() {
    if (this.props.model == 'company') {
      return this.props.companyManual;
    }
    if (this.props.model == 'vehicle') {
      return this.props.vehicleManual;
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  onDropdownChange(evt) {
    const value = evt.value;
    if (value == 'Manual') {
      this.props.onManual(true);
      this.props.onChange('');
    } else {
      this.props.onManual(false);
      this.props.onChange(evt.value);
    }
  }

  render() {
    let options =
      this.props.editable && this.props.type != 'language'
        ? this.props.options
            .map(val => ({ label: this.lbl(`${this.props.model}.property.${this.props.type}.${val}`), value: val }))
            .concat([{ label: 'anders', value: 'Manual' }])
        : this.props.options.map(val => ({
            label:
              this.props.type == 'currency' || this.props.type == 'language'
                ? val.name
                : this.lbl(`${this.props.model}.property.${this.props.type}.${val}`),
            value: this.props.type == 'currency' || this.props.type == 'language' ? val.value : val,
          }));

    const selected = options.find(o => o.value == this.value);

    return (
      <Container>
        {!this.manual && !this.value ? (
          <div>
            <SearchSelect
              options={options}
              value={selected}
              onChange={this.onDropdownChange.bind(this)}
              disabled={this.manual || this.props.disabled}
            />
          </div>
        ) : (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                value={this.value}
                disabled={!this.props.editable}
                onChange={evt => this.props.onChange(evt.target.value)}
                name="value"
              />
            </div>

            <ButtonComponent
              style={'ButtonSoftDelete'}
              disabled={this.props.disabled}
              onClick={() => {
                this.props.deletable && this.props.onDeleteValue(this.value);
                this.props.onManual(false);
                this.props.onReset();
              }}
            >
              <CircleTimes />
            </ButtonComponent>
          </div>
        )}
      </Container>
    );
  }
}

ManualDropdownComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicleValue: selectNewVehicleValue(ownProps.type),
    vehicleManual: selectNewVehicleValue(`${ownProps.type}_manual`),
    companyValue: selectNewCompanyValue(ownProps.type),
    companyManual: selectNewCompanyValue(`${ownProps.type}_manual`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ManualDropdown = compose(withConnect, withRouter)(ManualDropdownComp);
